var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable babel/new-cap */
import { Vue, Component, Watch } from 'vue-property-decorator';
import shareInit from '../share';
import Page0 from './page0.vue';
import Page1 from './page1.vue';
import Page2 from './page2.vue';
import Page3 from './page3.vue';
import Page4 from './page4.vue';
import Page5 from './page5.vue';
import Page6 from './page6.vue';
import Page7 from './page7.vue';
import Page8 from './page8.vue';
import RecommendPage from './recommend.vue';
import FinalPage from './final.vue';
import RuleToast from './toast.vue';
import { Action, Getter, State, Mutation } from 'vuex-class';
import { qrcodeUrl } from '../utils';
import logger from '@plat-components/utils2/_esm5/logger';
import { debounce } from 'throttle-debounce';
let Home = class Home extends Vue {
    constructor() {
        super(...arguments);
        this.inf = window.inf || false;
        this.wheelHandle = () => { };
        this.originY = 0;
        // showFinal = true
        this.lockScroll = false;
        this.mouseStartY = 0;
        this.scrollType = '';
        this.isPC = window.isPC || false;
        this.topImg = require('../assets/page8/top.png');
        this.topImgHide = require('../assets/top_hide.png');
        this.headerGif = require('../assets/header.gif');
    }
    get style() {
        return {
            transform: `translate(0,-${this.current * 100}vh)`,
            webkitTransform: `translate(0,-${this.current * 100}vh)`,
        };
    }
    get noPage4() {
        // console.log('page4?')
        return Object.keys(this.page4).length === 0 || !this.page4.ep_view_num || this.page4.ep_view_num <= 1 || !this.page4.season_title;
    }
    get noPage5() {
        return Object.keys(this.page5).length === 0 || (Object.keys(this.page5).length > 0 && !this.page5.season_title);
    }
    get noPage7() {
        return Object.keys(this.page7).length === 0 || this.page7.length < 3 || this.page7.some(i => !i);
    }
    get progressStyle() {
        // 97
        const progress = 2 - (this.current * 1) / this.totalCount;
        return {
            backgroundPosition: `${progress * 100}%`,
        };
    }
    handleCurrentChange() {
        const loggerNumber = this.current + 1;
        logger('page_show', { page_num: loggerNumber });
    }
    async mounted() {
        const u = window.navigator.userAgent;
        const isWechat = /MicroMessenger/i.test(u);
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        // 判断登录
        this.FETCH_LOGIN_INFO();
        // 设置分享信息
        shareInit();
        logger('page_show', { page_num: 1 });
        const qrcodeImg = await qrcodeUrl(window.shareUrl);
        this.SET_QRCODE(qrcodeImg);
        document.addEventListener('touchstart', (e) => {
            this.scrollType = '';
            this.originY = e.targetTouches[0].clientY;
        });
        document.addEventListener('touchmove', (e) => {
            if (isWechat && isAndroid && !this.toastVisible) {
                e.preventDefault();
            }
            if (e.targetTouches[0].clientY - this.originY >= 30) {
                if (!this.lockScroll) {
                    this.scrollType = 'prev';
                }
                this.lockScroll = true;
            }
            else if (e.targetTouches[0].clientY - this.originY <= -30) {
                if (!this.lockScroll) {
                    this.scrollType = 'next';
                }
                this.lockScroll = true;
            }
            else {
                this.scrollType = '';
            }
        }, {
            passive: false,
        });
        document.addEventListener('touchend', () => {
            this.lockScroll = false;
            this.handleScroll();
        });
        // pc端的适配
        document.addEventListener('mousedown', (e) => {
            this.mouseStartY = e.clientY;
        });
        document.addEventListener('mouseup', (e) => {
            if (!this.mouseStartY) {
                return;
            }
            if (e.clientY - this.mouseStartY >= 30) {
                this.scrollType = 'prev';
            }
            else if (e.clientY - this.mouseStartY <= -30) {
                this.scrollType = 'next';
            }
            else {
                this.scrollType = '';
            }
            this.handleScroll();
        });
        this.wheelHandle = debounce(100, true, this.wheelEvent);
        document.addEventListener('wheel', this.wheelHandle, false);
    }
    wheelEvent(e) {
        if (this.toastVisible || !this.isAgree || this.userInfo.isLogin !== true || this.lockScroll) {
            return;
        }
        this.lockScroll = true;
        const event = e || window.event;
        if (event.wheelDelta) {
            // 判断浏览器IE，谷歌滑轮事件
            if (event.wheelDelta < 0) {
                // 当滑轮向上滚动时
                // this.current < this.totalCount && this.SET_CURRENT('next')
                this.scrollType = 'next';
            }
            if (event.wheelDelta > 0) {
                this.scrollType = 'prev';
            }
        }
        else if (event.detail) {
            // Firefox滑轮事件
            if (event.detail < 0) {
                // 当滑轮向上滚动时
                this.scrollType = 'next';
            }
            if (event.detail > 0) {
                this.scrollType = 'prev';
            }
        }
        this.lockScroll = false;
        this.handleScroll();
    }
    handleScroll() {
        if (this.toastVisible || !this.isAgree || this.userInfo.isLogin !== true || !this.scrollType || this.lockScroll) {
            return;
        }
        if (this.scrollType === 'next' && this.current < this.totalCount) {
            this.current < this.totalCount && this.SET_CURRENT('next');
        }
        else if (this.scrollType === 'prev' && this.current >= 1) {
            this.current > 0 && this.SET_CURRENT('prev');
        }
    }
    handleToggleClick() {
        if (this.showInfo) {
            logger('button_hide');
        }
        else {
            logger('button_not_hide');
        }
        this.TOGGLE_SHOWINFO(!this.showInfo);
    }
};
__decorate([
    State
], Home.prototype, "current", void 0);
__decorate([
    State
], Home.prototype, "totalCount", void 0);
__decorate([
    State
], Home.prototype, "userInfo", void 0);
__decorate([
    State
], Home.prototype, "showInfo", void 0);
__decorate([
    State
], Home.prototype, "isAgree", void 0);
__decorate([
    State
], Home.prototype, "toastVisible", void 0);
__decorate([
    State
], Home.prototype, "qrcodeImg", void 0);
__decorate([
    Getter
], Home.prototype, "page8", void 0);
__decorate([
    Getter
], Home.prototype, "page5", void 0);
__decorate([
    Getter
], Home.prototype, "page7", void 0);
__decorate([
    Getter
], Home.prototype, "page4", void 0);
__decorate([
    Getter
], Home.prototype, "generatorImg", void 0);
__decorate([
    Getter
], Home.prototype, "hideTop", void 0);
__decorate([
    Getter
], Home.prototype, "h5WidthStyle", void 0);
__decorate([
    Getter
], Home.prototype, "h5HeightStyle", void 0);
__decorate([
    Action
], Home.prototype, "FETCH_LOGIN_INFO", void 0);
__decorate([
    Action
], Home.prototype, "GET_RECOMMEND_LIST", void 0);
__decorate([
    Mutation
], Home.prototype, "SET_CURRENT", void 0);
__decorate([
    Mutation
], Home.prototype, "SET_QRCODE", void 0);
__decorate([
    Mutation
], Home.prototype, "TOGGLE_SHOWINFO", void 0);
__decorate([
    Watch('current')
], Home.prototype, "handleCurrentChange", null);
Home = __decorate([
    Component({
        components: {
            Page0,
            Page1,
            Page2,
            Page3,
            Page4,
            Page5,
            Page6,
            Page7,
            Page8,
            RuleToast,
            FinalPage,
            RecommendPage,
        },
    })
], Home);
export default Home;
